import { render, staticRenderFns } from "./_editorder.vue?vue&type=template&id=7337f317&"
import script from "./_editorder.vue?vue&type=script&lang=ts&"
export * from "./_editorder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Thermotech\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7337f317')) {
      api.createRecord('7337f317', component.options)
    } else {
      api.reload('7337f317', component.options)
    }
    module.hot.accept("./_editorder.vue?vue&type=template&id=7337f317&", function () {
      api.rerender('7337f317', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Dev/js/components/mypages/_editorder.vue"
export default component.exports